import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/kidizen-shipping';

export default function Example() {
  return (
    <>
      <Head>
        <title>Selling On Kidizen? Here's a Refresher for How Their Shipping Works</title>
        <meta
          name='description'
          content='Learn the basic logistics of selling on Kidizen, a popular resale site for kids clothings as a seller, from shipping labels and shipping time in Kidizen'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/kidizen-shipping' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/kidizen-shipping' />
        <meta property='og:title' content="Selling On Kidizen? Here's a Refresher for How Their Shipping Works" />
        <meta
          property='og:description'
          content='Learn the basic logistics of selling on Kidizen, a popular resale site for kids clothings as a seller, from shipping labels and shipping time in Kidizen'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='Kidizen' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
